export const getLocalStorageFlag = (flagName: string, eventId: string) => {
  return `${eventId}_${flagName}`;
};

export const setSearchParamToPath = (path: string, param: string, value: string) => {
  const [cleanPath, params] = path.split('?');
  const searchParams = new URLSearchParams(params);

  searchParams.set(param, value);

  return `${cleanPath}?${searchParams.toString()}`;
};
